import './dom-53c9635b.js';
import { i as isUndefined } from './isUndefined-3eca6e32.js';

/**
 * Determines whether the `value` is `null` or `undefined`.
 */
const isNil = value => {
  return isNull(value) || isUndefined(value);
};

/**
 * Determines whether the `value` is `null`.
 */
const isNull = value => {
  return value === null;
};

export { isNull as a, isNil as i };
